export var derivativeDetailsMapper = function (data) {
    var _a, _b, _c, _d, _e;
    var result = [];
    if (data &&
        (data === null || data === void 0 ? void 0 : data.data) &&
        ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.resLst) &&
        ((_c = (_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.resLst) === null || _c === void 0 ? void 0 : _c.length) > 0) {
        (_e = (_d = data === null || data === void 0 ? void 0 : data.data) === null || _d === void 0 ? void 0 : _d.resLst) === null || _e === void 0 ? void 0 : _e.map(function (derivative) {
            var res = {};
            res.displayName = derivative.dpNm;
            res.displayValue = derivative.dpVal;
            res.strikePrice = derivative.stkPrc;
            res.lotSize = derivative.lsz;
            res.symbol = derivative.sym;
            result.push(res);
        });
    }
    return result;
};
